<template>
<q-list class="comment-list" ref="innerList">
  <common-comment
      v-for="comment in comments.data"
      :comment="comment"
      :key="comment.id"
      :current-user="currentUser"
      :project-id="projectId"
  />
  <q-item v-if="comments.last_page > 1" class="flex flex-center">
    <pagination-links :items="comments"
                      :mini="!maxView"
                      @navigate="goToPage" />
  </q-item>
</q-list>
</template>

<script>
import { useProjectComents } from '../../stores/useProjectComments'

export default {
  props: {
    comments: {
      type: Object,
      default: null,
    },
    maxView: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: Number,
    },
  },
  setup () {
    const projectComments = useProjectComents()
    return {
      projectComments,
    }
  },
  methods: {
    goToPage (page) {
      this.projectComments.setPage(page)
      this.$refs.innerList.$el.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' })
    },
  },
}
</script>
